import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import ReactPlayer from "react-player";

import swal from "sweetalert";
import JudgeMarkForm from "./JudgeMarkForm";

const AuditionLiveJudgeAssesmentModal = (props) => {
  const { setVideoUrl } = props;
  const { assigned_judges } = props.event;
  const { user_uploaded_video } = props.auditionParticipant;

  // const modalHide = () => {

  // };

  const user_id = props.userId;

  useEffect(() => {
    axios
      .get(
        `/api/audition-admin/audition-mark/uploadedVideo/${user_id}/${props?.event?.id}/${props?.event?.active_round_info_id}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
        }
      });
  }, []);

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body className="AuditionLiveJudge">
          <div className="d-flex justify-content-between mb-3">
            <h3 className="decline-form text-warning fw-bold">
              Enter Marks and Comments
            </h3>

            <i
              className="fa-solid fa-xmark text-warning"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setVideoUrl(true);
                props.onHide();
              }}
            ></i>
          </div>

          <Table striped bordered hover variant="dark" className="text-center">
            <thead>
              {/* <tr>
                <th>Judge</th>
                <th className="mark-number">Mark</th>
                <th>Comments</th>
              </tr> */}
            </thead>
            <tbody>
              {assigned_judges.map((judge, index) => (
                <JudgeMarkForm
                  setVideoUrl={setVideoUrl}
                  judge={judge}
                  user_id={user_id}
                  audition_id={props.event.id}
                  round_info_id={props.event.active_round_info_id}
                  key={index}
                />
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AuditionLiveJudgeAssesmentModal;
